import {addSymbol, removeLastSymbol, clear} from 'ui/keyboard';

export interface KeyboardCommands {
  removeLastSymbol(state: KeyboardState): KeyboardState;
  addSymbol(state: KeyboardState, symbol: string): KeyboardState;
  clear(): KeyboardState;
}

export const commands: KeyboardCommands = {
  removeLastSymbol,
  addSymbol,
  clear,
};
